import { HTTP_METHODS } from '@shared/constants';

import Constants from '@/utils/constants';

export const login = {
	endPoint: `${Constants.SUB_URL_INSIGHTS}/v4/auth/web/login`,
	method: HTTP_METHODS.POST,
};

export const otpLoginInitiate = {
	endPoint: `${Constants.SUB_URL_INSIGHTS}/v2/auth/web/login/initiate`,
	method: HTTP_METHODS.POST,
};

export const forgotPassword = {
	endPoint: `${Constants.SUB_URL_INSIGHTS}/v1/auth/forgotPassword`,
	method: HTTP_METHODS.POST,
};

export const getRolesList = {
	endPoint: `${Constants.SUB_URL_INSIGHTS}/v1/user/role`,
	method: HTTP_METHODS.GET,
};

export const getUserPermissions = {
	endPoint: `${Constants.SUB_URL_INSIGHTS}/v1/user/permissions`,
	method: HTTP_METHODS.GET,
};

export const getUserDetail = {
	endPoint: `${Constants.SUB_URL_INSIGHTS}/v1/user/me`,
	method: HTTP_METHODS.GET,
};

export const logout = {
	endPoint: `${Constants.SUB_URL_INSIGHTS}/v1/auth/logout`,
	method: HTTP_METHODS.POST,
};

export const getUsersList = {
	endPoint: `${Constants.SUB_URL_INSIGHTS}/v1/user/list`,
	method: HTTP_METHODS.GET,
};

export const deleteUser = {
	endPoint: `${Constants.SUB_URL_INSIGHTS}/v1/user/:userId`,
	method: HTTP_METHODS.DELETE,
};

export const createUser = {
	endPoint: `${Constants.SUB_URL_INSIGHTS}/v2/user/createUser`,
	method: HTTP_METHODS.POST,
};

export const assignUserRole = {
	endPoint: `${Constants.SUB_URL_INSIGHTS}/v1/user/:userId/role/:roleId`,
	method: HTTP_METHODS.POST,
};

export const deleteAssignedRole = {
	endPoint: `${Constants.SUB_URL_INSIGHTS}/v1/user/:userId/role/:roleId`,
	method: HTTP_METHODS.PUT,
};

export const getMerchantProfile = {
	endPoint: `${Constants.SUB_URL_MERCHANT_ONBOARDING}/v1/merchant/profile`,
	method: HTTP_METHODS.GET,
};

export const getPaymentOptions = {
	endPoint: `${Constants.SUB_URL_MERCHANT_ONBOARDING}/v1/merchant/paymentOptions`,
	method: HTTP_METHODS.GET,
};

export const setPassword = {
	endPoint: `${Constants.SUB_URL_INSIGHTS}/v1/user/setPassword`,
	method: HTTP_METHODS.POST,
};

export const getQRList = {
	endPoint: `${Constants.SUB_URL_INSIGHTS}/v1/qrpos/list`,
	method: HTTP_METHODS.GET,
};

export const getQRText = {
	endPoint: `${Constants.SUB_URL_MERCHANT_ONBOARDING}/v1/merchant/qrcode/:id/text`,
	method: HTTP_METHODS.GET,
};

export const downloadQR = {
	endPoint: `${Constants.SUB_URL_INSIGHTS}/v1/qrpos/qrdownload`,
	method: HTTP_METHODS.POST,
};

export const getOTPNotificationReceiver = {
	endPoint: `${Constants.SUB_URL_MERCHANT_ONBOARDING}/v1/merchant/qrpos/add/QR_CODE/:qrCodeId/notification`,
	method: HTTP_METHODS.POST,
};

export const resendOTPNotificationReceiver = {
	endPoint: `${Constants.SUB_URL_MERCHANT_ONBOARDING}/v1/merchant/qrpos/resendOtp`,
	method: HTTP_METHODS.POST,
};

export const verifyOTPNotificationReceiver = {
	endPoint: `${Constants.SUB_URL_MERCHANT_ONBOARDING}/v1/merchant/qrpos/verify/QR_CODE/:qrCodeId/otp`,
	method: HTTP_METHODS.POST,
};

export const deleteNotificationReceiver = {
	endPoint: `${Constants.SUB_URL_MERCHANT_ONBOARDING}/v1/merchant/qrpos/remove/QR_CODE/:qrCodeId/notification`,
	method: HTTP_METHODS.PUT,
};

export const getLiveTransactionsV2 = {
	endPoint: `${Constants.SUB_URL_EARNEST}/v1/transactions/recent`,
	method: HTTP_METHODS.POST,
};

export const getTransactionListV3 = {
	endPoint: `${Constants.SUB_URL_INSIGHTS}/v3/transactions/list`,
	method: HTTP_METHODS.POST,
};

export const getMerchantPaymentInstruments = {
	endPoint: `${Constants.SUB_URL_INSIGHTS}/v1/merchant/instrumentSolution`,
	method: HTTP_METHODS.GET,
};

export const createPaylink = {
	endPoint: `${Constants.SUB_URL_ATHENA}/v1/paylink`,
	method: HTTP_METHODS.POST,
};

export const resendPaylink = {
	endPoint: `${Constants.SUB_URL_ATHENA}/v1/paylink/:data/send-reminder`,
	method: HTTP_METHODS.PUT,
};

export const cancelPaylink = {
	endPoint: `${Constants.SUB_URL_ATHENA}/v1/paylink/:data/cancel`,
	method: HTTP_METHODS.PUT,
};

export const getPaylinks = {
	endPoint: `${Constants.SUB_URL_INSIGHTS}/v2/payLink/list`,
	method: HTTP_METHODS.POST,
};
export const getTransactionDetail = {
	endPoint: `${Constants.SUB_URL_INSIGHTS}/v3/transactions/details`,
	method: HTTP_METHODS.POST,
};
export const getTransactionDetailByUnitId = {
	endPoint: `${Constants.SUB_URL_INSIGHTS}/v3/transactions/unit/:unitId/details`,
	method: HTTP_METHODS.GET,
};
export const refundTransaction = {
	endPoint: `${Constants.SUB_URL_INSIGHTS}/v1/transactions/backToSource`,
	method: HTTP_METHODS.POST,
};
export const reportList = {
	endPoint: `${Constants.SUB_URL_INSIGHTS}/v2/reports/transaction`,
	method: HTTP_METHODS.GET,
};
export const getDailySettlements = {
	endPoint: `${Constants.SUB_URL_INSIGHTS}/v1/reports/settlement/month`,
	method: HTTP_METHODS.POST,
};
export const merchantList = {
	endPoint: `${Constants.SUB_URL_MERCHANT_ONBOARDING}/v1/merchant/list`,
	method: HTTP_METHODS.GET,
};
export const downloadReport = {
	endPoint: `${Constants.SUB_URL_INSIGHTS}/v1/reports/:id`,
	method: HTTP_METHODS.GET,
};
export const getMonthlySettlement = {
	endPoint: `${Constants.SUB_URL_INSIGHTS}/v1/reports/settlement/year`,
	method: HTTP_METHODS.POST,
};
export const getGstInvoice = {
	endPoint: `${Constants.SUB_URL_INSIGHTS}/v1/reports/gst`,
	method: HTTP_METHODS.POST,
};
export const getRecentSettlements = {
	endPoint: `${Constants.SUB_URL_INSIGHTS}/v1/settlements/changes`,
	method: HTTP_METHODS.POST,
};
export const downloadRecentSettlementReport = {
	endPoint: `${Constants.SUB_URL_INSIGHTS}/v1/settlements/download/:data`,
	method: HTTP_METHODS.GET,
};

export const getDefaultReportTemplate = {
	endPoint: `${Constants.SUB_URL_INSIGHTS}/v1/reports/context`,
	method: HTTP_METHODS.GET,
};

export const getSettlementReportTemplates = {
	endPoint: `${Constants.SUB_URL_INSIGHTS}/v1/reports/templates`,
	method: HTTP_METHODS.GET,
};

export const updateDefaultReportTemplate = {
	endPoint: `${Constants.SUB_URL_INSIGHTS}/v1/reports/context`,
	method: HTTP_METHODS.PUT,
};

export const trends = {
	endPoint: `${Constants.SUB_URL_INSIGHTS}/v3/transactions/metrics/stats`,
	method: HTTP_METHODS.POST,
};
export const getBatchRefunds = {
	endPoint: `${Constants.SUB_URL_INSIGHTS}/v1/batch/refunds`,
	method: HTTP_METHODS.GET,
};
export const downloadBatchFile = {
	endPoint: `${Constants.SUB_URL_INSIGHTS}/v1/batch/download/:batchId`,
	method: HTTP_METHODS.GET,
};
export const downloadBulkRefundTemplate = {
	endPoint: `${Constants.SUB_URL_INSIGHTS}/v1/batch/template/download`,
	method: HTTP_METHODS.GET,
};
export const uploadBatchFile = {
	endPoint: `${Constants.SUB_URL_INSIGHTS}/v1/batch/process`,
	method: HTTP_METHODS.POST,
};
export const generateReport = {
	endPoint: `${Constants.SUB_URL_INSIGHTS}/v2/reports/transaction/generate`,
	method: HTTP_METHODS.POST,
};
export const getMerchantHashId = {
	endPoint: `${Constants.SUB_URL_INSIGHTS}/v1/merchant/entityType/MERCHANT/entityId/:merchantId`,
	method: HTTP_METHODS.POST,
};
export const getStoreDetail = {
	endPoint: `${Constants.SUB_URL_INSIGHTS}/v2/stores/:merchantId/:storeId/details`,
	method: HTTP_METHODS.GET,
};
export const updateStore = {
	endPoint: `${Constants.SUB_URL_MERCHANT_ONBOARDING}/v1/store/:merchantId/:storeId`,
	method: HTTP_METHODS.PATCH,
};
export const getAddressFromLocation = {
	endPoint: `${Constants.SUB_URL_INSIGHTS}/v1/stores/geolocation/reverseGeocode`,
	method: HTTP_METHODS.GET,
};
export const getAddressFromPinCode = {
	endPoint: `${Constants.SUB_URL_INSIGHTS}/v1/stores/geolocation/geocode`,
	method: HTTP_METHODS.GET,
};
export const addStoreImage = {
	endPoint: `${Constants.SUB_URL_INSIGHTS}/v1/merchant/uploadImage`,
	method: HTTP_METHODS.POST,
};
export const deleteStoreImage = {
	endPoint: `${Constants.SUB_URL_MERCHANT_ONBOARDING}/v1/merchant/document/:imageId`,
	method: HTTP_METHODS.DELETE,
};
export const getStorePhoneUpdateOtp = {
	endPoint: `${Constants.SUB_URL_MERCHANT_ONBOARDING}/v1/store/phoneNumber/requestOtp`,
	method: HTTP_METHODS.POST,
};
export const verifyStorePhoneUpdateOtp = {
	endPoint: `${Constants.SUB_URL_MERCHANT_ONBOARDING}/v1/store/phoneNumber/verifyOtp`,
	method: HTTP_METHODS.POST,
};
export const getHolidayList = {
	endPoint: `${Constants.SUB_URL_INSIGHTS}/v1/dashboard/getSettlementHolidayList`,
	method: HTTP_METHODS.GET,
};
export const getTerminalList = {
	endPoint: `${Constants.SUB_URL_MERCHANT_ONBOARDING}/v1/store/:merchantId/:storeId/terminals`,
	method: HTTP_METHODS.GET,
};
export const getDailyReportData = {
	endPoint: `${Constants.SUB_URL_INSIGHTS}/v1/reports/transaction`,
	method: HTTP_METHODS.POST,
};
export const changeUserData = {
	endPoint: `${Constants.SUB_URL_INSIGHTS}/v1/user/update/:userId`,
	method: HTTP_METHODS.PUT,
};
export const updateMerchantEmail = {
	endPoint: `${Constants.SUB_URL_INSIGHTS}/v1/user/update/merchant/:merchantId/email`,
	method: HTTP_METHODS.PUT,
};
export const verifyHurdleOTP = {
	endPoint: `${Constants.SUB_URL_INSIGHTS}/v1/user/hurdles/v1/instance/:instanceId/execute`,
	method: HTTP_METHODS.POST,
};
export const resendOTPForEmailUpdate = {
	endPoint: `${Constants.SUB_URL_INSIGHTS}/v1/user/hurdles/v1/instance/multiotp/request`,
	method: HTTP_METHODS.POST,
};
export const verifyUser = {
	endPoint: `${Constants.SUB_URL_INSIGHTS}/v1/auth/verify/:verificationKey`,
	method: HTTP_METHODS.GET,
};
export const updateMerchantInfo = {
	endPoint: `${Constants.SUB_URL_MERCHANT_ONBOARDING}/v1/merchant/profile/update`,
	method: HTTP_METHODS.PATCH,
};
export const updateMerchantAddress = {
	endPoint: `${Constants.SUB_URL_MERCHANT_ONBOARDING}/v1/merchant/profile/update`,
	method: HTTP_METHODS.PATCH,
};
export const getGroupSelectionList = {
	endPoint: `${Constants.SUB_URL_INSIGHTS}/v1/user/groupSelection`,
	method: HTTP_METHODS.GET,
};
export const updateUserGroup = {
	endPoint: `${Constants.SUB_URL_INSIGHTS}/v1/user/updateSession`,
	method: HTTP_METHODS.POST,
};
export const getUserLinkedStoreAccess = {
	endPoint: `${Constants.SUB_URL_INSIGHTS}/v1/user/listAccessForUser`,
	method: HTTP_METHODS.POST,
};
export const getStoreList = {
	endPoint: `${Constants.SUB_URL_INSIGHTS}/v2/stores`,
	method: HTTP_METHODS.GET,
};
export const addStoreAccessToUser = {
	endPoint: `${Constants.SUB_URL_INSIGHTS}/v1/user/addAccessToUser/:userId`,
	method: HTTP_METHODS.POST,
};
export const removeStoreAccessToUser = {
	endPoint: `${Constants.SUB_URL_INSIGHTS}/v1/user/removeAccess/:userId`,
	method: HTTP_METHODS.PUT,
};
export const getChatBotToken = {
	endPoint: `${Constants.SUB_URL_INSIGHTS}/v1/merchant/generateBotToken`,
	method: HTTP_METHODS.GET,
};
export const refreshToken = {
	endPoint: `${Constants.SUB_URL_INSIGHTS}/v1/auth/refresh`,
	method: HTTP_METHODS.POST,
};
export const removeAuthCookies = {
	endPoint: `${Constants.SUB_URL_INSIGHTS}/v1/user/reset`,
	method: HTTP_METHODS.GET,
};
export const getMerchantOnboardingDetails = {
	endPoint: `${Constants.SUB_URL_MERCHANT_ONBOARDING}/v1/om/merchant`,
	method: HTTP_METHODS.GET,
};
export const getChimeraConfig = {
	endPoint: `${Constants.SUB_URL_CHIMERA}/pz/v1/PFB_WEB/merchant/:merchantId/evaluate/bulk`,
	method: HTTP_METHODS.POST,
};
export const getSettlementReportStatus = {
	endPoint: `${Constants.SUB_URL_INSIGHTS}/v1/reports/:merchantId/:urn/status`,
	method: HTTP_METHODS.GET,
};
export const getMonthlySettlementReport = {
	endPoint: `${Constants.SUB_URL_INSIGHTS}/v2/reports/settlement/monthly`,
	method: HTTP_METHODS.GET,
};
export const generateSettlementReport = {
	endPoint: `${Constants.SUB_URL_INSIGHTS}/v1/reports/settlement/generate`,
	method: HTTP_METHODS.POST,
};
export const bullhornRequestTopics = {
	endPoint: `${Constants.SUB_URL_BULLHORN}/merchants/topics/sync/v2/:merchantUserId`,
	method: HTTP_METHODS.POST,
};
export const bullhornRequestSync = {
	endPoint: `${Constants.SUB_URL_BULLHORN}/merchants/sync/v2/:merchantUserId`,
	method: HTTP_METHODS.POST,
};
export const bullhornRequestRestore = {
	endPoint: `${Constants.SUB_URL_BULLHORN}/merchants/restore/v2/:merchantUserId`,
	method: HTTP_METHODS.POST,
};
export const fetchIrisAccessToken = {
	endPoint: `${Constants.SUB_URL_IRISMX}/v1/auth/init`,
	method: HTTP_METHODS.POST,
};
export const getApiKeysList = {
	endPoint: `${Constants.SUB_URL_OM_INSIGHTS}/v2/merchant/keys/meta-info`,
	method: HTTP_METHODS.POST,
};
export const getEncryptedApiKeys = {
	endPoint: `${Constants.SUB_URL_OM_INSIGHTS}/v2/merchant/keys/view`,
	method: HTTP_METHODS.POST,
};
export const updateMerchantConfig = {
	endPoint: `${Constants.SUB_URL_OM_INSIGHTS}/v1/config/update`,
	method: HTTP_METHODS.POST,
};
export const getDashboardStartupConfigDetails = {
	endPoint: `${Constants.SUB_URL_OM_INSIGHTS}/v1/dashboard/startup/config`,
	method: HTTP_METHODS.GET,
};
export const sendFoxtrotEvents = {
	endPoint: `${Constants.SUB_URL_UIL}/v5/bulk/ingest`,
	method: HTTP_METHODS.POST,
};
export const omReportList = {
	endPoint: `${Constants.SUB_URL_OM_INSIGHTS}/v1/report/transaction`,
	method: HTTP_METHODS.GET,
};
export const omGenerateReport = {
	endPoint: `${Constants.SUB_URL_OM_INSIGHTS}/v1/report/transaction/generate`,
	method: HTTP_METHODS.POST,
};
export const omDownloadReport = {
	endPoint: `${Constants.SUB_URL_OM_INSIGHTS}/v1/report/:id`,
	method: HTTP_METHODS.GET,
};
export const initServiceLineForB2B = {
	endPoint: `${Constants.SUB_URL_OM_INSIGHTS}/v2/merchant/service-line/init`,
	method: HTTP_METHODS.POST,
};
export const getServiceLineDetails = {
	endPoint: `${Constants.SUB_URL_OM_INSIGHTS}/v1/service-line/:serviceLine`,
	method: HTTP_METHODS.GET,
};
export const getServiceLinesList = {
	endPoint: `${Constants.SUB_URL_MERCHANT_ONBOARDING}/v1/serviceline/merchants/:merchantId/details`,
	method: HTTP_METHODS.GET,
};
export const getBusinessSuperCategoryList = {
	endPoint: `${Constants.SUB_URL_MERCHANT_ONBOARDING}/v1/om/categoryTree/superCategories`,
	method: HTTP_METHODS.GET,
};
export const getBusinessCategoryList = {
	endPoint: `${Constants.SUB_URL_MERCHANT_ONBOARDING}/v1/om/categoryTree/node/:categoryNodeId`,
	method: HTTP_METHODS.GET,
};
export const getPincodeDetails = {
	endPoint: `${Constants.SUB_URL_MERCHANT_ONBOARDING}/v1/om/pincode/:pincode/details`,
	method: HTTP_METHODS.GET,
};
export const updateMerchantDetails = {
	endPoint: `${Constants.SUB_URL_MERCHANT_ONBOARDING}/v1/om/merchant/profile`,
	method: HTTP_METHODS.PATCH,
};
export const kycInitV2 = {
	endPoint: `${Constants.SUB_URL_OM_INSIGHTS}/v2/merchant/kyc/init`,
	method: HTTP_METHODS.POST,
};
export const kycInit = {
	endPoint: `${Constants.SUB_URL_MERCHANT_ONBOARDING}/v1/om/kyc/init`,
	method: HTTP_METHODS.POST,
};
export const getKycStatus = {
	endPoint: `${Constants.SUB_URL_MERCHANT_ONBOARDING}/v1/om/journey`,
	method: HTTP_METHODS.POST,
};
export const initServiceLine = {
	endPoint: `${Constants.SUB_URL_MERCHANT_ONBOARDING}/v1/serviceline/init`,
	method: HTTP_METHODS.POST,
};
export const sentEmailVerification = {
	endPoint: `${Constants.SUB_URL_INSIGHTS}/v1/user/sendVerificationLink`,
	method: HTTP_METHODS.POST,
};
export const getWebhookEvents = {
	endPoint: `${Constants.SUB_URL_OM_INSIGHTS}/v1/webhooks/events`,
	method: HTTP_METHODS.GET,
};
export const getWebhooksList = {
	endPoint: `${Constants.SUB_URL_OM_INSIGHTS}/v1/webhooks`,
	method: HTTP_METHODS.GET,
};
export const createWebhook = {
	endPoint: `${Constants.SUB_URL_OM_INSIGHTS}/v1/webhooks`,
	method: HTTP_METHODS.POST,
};
export const editWebhook = {
	endPoint: `${Constants.SUB_URL_OM_INSIGHTS}/v1/webhooks/:webhookId`,
	method: HTTP_METHODS.PUT,
};
export const deleteWebhook = {
	endPoint: `${Constants.SUB_URL_OM_INSIGHTS}/v1/webhooks/:webhookId`,
	method: HTTP_METHODS.DELETE,
};
export const sendOtp = {
	endPoint: `${Constants.SUB_URL_INSIGHTS}/v3/auth/web/sendOtp`,
	method: HTTP_METHODS.POST,
};
export const submitOtp = {
	endPoint: `${Constants.SUB_URL_INSIGHTS}/v3/auth/web/login`,
	method: HTTP_METHODS.POST,
};
export const initConsent = {
	endPoint: `${Constants.SUB_URL_OM_INSIGHTS}/v1/consent/init`,
	method: HTTP_METHODS.POST,
};
export const fetchPoliciesPreview = {
	endPoint: `${Constants.SUB_URL_OM_INSIGHTS}/v1/consent/approve`,
	method: HTTP_METHODS.POST,
};
export const downloadPolicies = {
	endPoint: `${Constants.SUB_URL_OM_INSIGHTS}/v1/document/download`,
	method: HTTP_METHODS.POST,
};
export const initiateMira = {
	endPoint: `${Constants.SUB_URL_MERCHANT_ONBOARDING}/v1/crawler/:merchantId/init`,
	method: HTTP_METHODS.POST,
};
export const getMiraReport = {
	endPoint: `${Constants.SUB_URL_MERCHANT_ONBOARDING}/v1/crawler/:merchantId/report`,
	method: HTTP_METHODS.GET,
};
export const geMerchantJourneyStatus = {
	endPoint: `${Constants.SUB_URL_MERCHANT_ONBOARDING}/v1/om/journey`,
	method: HTTP_METHODS.POST,
};
export const fetchMaskedDetails = {
	endPoint: `${Constants.SUB_URL_OM_INSIGHTS}/v1/referrals/fetchMaskedDetails/:referralCode`,
	method: HTTP_METHODS.GET,
};
export const validateMaskedDetails = {
	endPoint: `${Constants.SUB_URL_OM_INSIGHTS}/v1/referrals/validate`,
	method: HTTP_METHODS.POST,
};
export const verifyMerchantLoginRedirection = {
	endPoint: `${Constants.SUB_URL_OM_INSIGHTS}/v1/merchant/auth/callback`,
	method: HTTP_METHODS.POST,
};
export const createOnlinePaylink = {
	endPoint: `${Constants.SUB_URL_OM_INSIGHTS}/v1/paylink`,
	method: HTTP_METHODS.POST,
};
export const getOnlinePaylinks = {
	endPoint: `${Constants.SUB_URL_OM_INSIGHTS}/v1/paylink/list`,
	method: HTTP_METHODS.POST,
};
export const cancelOnlinePaylink = {
	endPoint: `${Constants.SUB_URL_OM_INSIGHTS}/v1/paylink/cancel`,
	method: HTTP_METHODS.POST,
};
export const resendOnlinePaylink = {
	endPoint: `${Constants.SUB_URL_OM_INSIGHTS}/v1/paylink/notify`,
	method: HTTP_METHODS.POST,
};
export const getOnlineTransactionList = {
	endPoint: `${Constants.SUB_URL_OM_INSIGHTS}/v1/transactions/list`,
	method: HTTP_METHODS.POST,
};
export const getTransactionListNonAbort = {
	endPoint: `${Constants.SUB_URL_OM_INSIGHTS}/v1/transactions/list`,
	method: HTTP_METHODS.POST,
};
export const getOnlineTransactionDetailByUnitId = {
	endPoint: `${Constants.SUB_URL_OM_INSIGHTS}/v1/transactions/unit/:transactionId/details`,
	method: HTTP_METHODS.GET,
};
export const getReportEmailList = {
	endPoint: `${Constants.SUB_URL_INSIGHTS}/v2/reports/list/email`,
	method: HTTP_METHODS.GET,
};
export const generateCustomSettlementReport = {
	endPoint: `${Constants.SUB_URL_INSIGHTS}/v2/reports/settlement/generate`,
	method: HTTP_METHODS.POST,
};
export const getMerchantAccountDetails = {
	endPoint: `${Constants.SUB_URL_VALHALLA}/v1/pfb/getAccountDetails/:merchantId`,
	method: HTTP_METHODS.GET,
};
export const getBankDetailsUsingIfsc = {
	endPoint: `${Constants.SUB_URL_MERCHANT_ONBOARDING}/v1/branch/:ifsc`,
	method: HTTP_METHODS.GET,
};
export const getSimulatorAuth = {
	endPoint: `${Constants.SUB_URL_OM_INSIGHTS}/v1/merchant/auth/simulator`,
	method: HTTP_METHODS.GET,
};
export const simulatorLogin = {
	endPoint: `${Constants.SUB_URL_SIMULATOR}/v1/auth/primer/login`,
	method: HTTP_METHODS.POST,
};
export const refreshTestModeToken = {
	endPoint: `${Constants.SUB_URL_SIMULATOR}/v1/auth/primer/refresh`,
	method: HTTP_METHODS.POST,
};
export const getApiTestKeys = {
	endPoint: `${Constants.SUB_URL_SIMULATOR}/v1/auth/generate-test-keys`,
	method: HTTP_METHODS.POST,
};
export const getWebsiteType = {
	endPoint: `${Constants.SUB_URL_OM_INSIGHTS}/v1/website-type-detector/detect`,
	method: HTTP_METHODS.GET,
};
export const getSuccessRateAnalyticsData = {
	endPoint: `${Constants.SUB_URL_INSIGHTS}/v1/analytics/pg/successrate`,
	method: HTTP_METHODS.POST,
};
export const getSuccessRateLastUpdate = {
	endPoint: `${Constants.SUB_URL_INSIGHTS}/v1/analytics/pg/lastdatainfo`,
	method: HTTP_METHODS.GET,
};

//Split Settlements
export const getSelfAccountsList = {
	endPoint: `${Constants.SUB_URL_OM_INSIGHTS}/v1/merchant/bank-account/list`,
	method: HTTP_METHODS.GET,
};

export const addNewSelfAccount = {
	endPoint: `${Constants.SUB_URL_MERCHANT_ONBOARDING}/v1/workflow/merchant/add-bank-account`,
	method: HTTP_METHODS.POST,
};

export const initOnboarding = {
	endPoint: `${Constants.SUB_URL_MERCHANT_ONBOARDING}/v1/workflow/merchant/init-account-verification`,
	method: HTTP_METHODS.POST,
};

export const updateSelfBankStatus = {
	endPoint: `${Constants.SUB_URL_MERCHANT_ONBOARDING}/v1/merchant/bank-account/:accountId/:type`,
	method: HTTP_METHODS.PUT,
};

export const getVendorAccountsList = {
	endPoint: `${Constants.SUB_URL_OM_INSIGHTS}/v1/vendor/list`,
	method: HTTP_METHODS.GET,
};

export const getVendorProfileDetails = {
	endPoint: `${Constants.SUB_URL_OM_INSIGHTS}/v1/vendor/:vendorId`,
	method: HTTP_METHODS.GET,
};

export const updateVendorBankStatus = {
	endPoint: `${Constants.SUB_URL_MERCHANT_ONBOARDING}/v1/merchant/vendor/:vendorId/:type`,
	method: HTTP_METHODS.PUT,
};

export const addNewVendorAccount = {
	endPoint: `${Constants.SUB_URL_MERCHANT_ONBOARDING}/v1/workflow/merchant/add-vendor`,
	method: HTTP_METHODS.POST,
};

export const initVendorOnboarding = {
	endPoint: `${Constants.SUB_URL_MERCHANT_ONBOARDING}/v1/workflow/merchant/vendor/kyc/init`,
	method: HTTP_METHODS.POST,
};

export const getVendorJourneyDetails = {
	endPoint: `${Constants.SUB_URL_MERCHANT_ONBOARDING}/v1/workflow/merchant/:merchantId/vendor/:vendorId/journey`,
	method: HTTP_METHODS.GET,
};

export const resendEDDLink = {
	endPoint: `${Constants.SUB_URL_MERCHANT_ONBOARDING}/v1/workflow/merchant/vendor/:vendorId/edd-link/resend`,
	method: HTTP_METHODS.POST,
};

export const getVendorMetaDetails = {
	endPoint: `${Constants.SUB_URL_MERCHANT_ONBOARDING}/v1/workflow/merchant/vendor/linkMeta/:metaId`,
	method: HTTP_METHODS.GET,
};

export const initEddWorkflow = {
	endPoint: `${Constants.SUB_URL_MERCHANT_ONBOARDING}/v1/workflow/merchant/vendor/edd/init`,
	method: HTTP_METHODS.POST,
};

export const initiateVendorOtp = {
	endPoint: `${Constants.SUB_URL_INSIGHTS}/v5/auth/vendor/web/sendOtp`,
	method: HTTP_METHODS.POST,
};

export const initiateVendorLogin = {
	endPoint: `${Constants.SUB_URL_INSIGHTS}/v5/auth/vendor/web/login`,
	method: HTTP_METHODS.POST,
};
